var exports = {
  "k": "x234b8571--ec128f--container",
};

module.exports = exports;
